<script setup lang="ts">
throw new Error('Hi')
</script>
